import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type ReplaceIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const ReplaceIllustration = ({ ...props }: ReplaceIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeLinecap="square" fill="none">
      <polyline points="22,40 2,40 2,2 36,2 36,18 " />
      <rect height="38" width="34" x="28" y="24" />
      <path d="M44,10h8c4.418,0,8,3.582,8,8v0" strokeLinecap="butt" />
      <polyline points=" 50,4 44,10 50,16 " />
      <path d="M20,54h-8c-4.418,0-8-3.582-8-8 v0" strokeLinecap="butt" />
      <polyline points=" 14,60 20,54 14,48 " />
    </g>
  </BaseIllustration>
);

ReplaceIllustration.displayName = 'ReplaceIllustration';
